import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";

export function DeleteConfirmDialog({ deleteId, onClose, onConfirm }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm(deleteId);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!deleteId} onClose={onClose}>
      <DialogTitle>確認刪除</DialogTitle>
      <DialogContent>您確定要刪除此地盤嗎？</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>取消</Button>
        <LoadingButton
          onClick={handleConfirm}
          color="error"
          variant="contained"
          loading={loading}
        >
          刪除
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
